<script>
import Item from '../Item.vue'
export default {
  props: {
    pointers: Array,
    steps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    subdomain() {
      return this.cname.value.split('.').slice(0, -2).join('.')
    },
    domain() {
      return this.cname.value.split('.').slice(-2).join('.')
    },
    cname() {
      return this.pointers.find(({ type }) => type === 'CNAME')
    },
    a() {
      return this.pointers.find(({ type }) => type === 'A')
    },
    items() {
      const aStatus = this.steps.A
      const cnameStatus = this.steps.CNAME

      const base = [
        {
          completed: aStatus || cnameStatus,
          content: 'Gå til <a href="https://www.webhuset.no/logg-inn/kundesenter">Webhuset</a> og logg inn',
        },
        {
          completed: aStatus || cnameStatus,
          content: `Naviger til "Domener" og klikk på <b>${this.domain}</b>`,
        },
        {
          completed: aStatus || cnameStatus,
          content: 'Naviger deretter til DNS og deretter DNS-oppføringer',
        },
        {
          completed: cnameStatus,
          content: 'Legg til en CNAME post',
          items: [
            'Trykk på “Ny oppføring”',
            'Trykk på “CNAME-oppføring”',
            'I feltet for "Oppføring", skriv inn www',
            {
              content: 'I feltet for "Alias av", skriv inn',
              target: this.cname.target,
            },
            'Lagre endringene ved å trykke på opprett',
            'Dersom du har en annen CNAME peker som benytter "Vertsnavn" www, må denne slettes slik at domenet fungerer riktig',
          ],
        },
      ]

      if (this.a) {
        return [
          ...base,
          {
            completed: aStatus,
            content: 'Legg til en A-post',
            items: [
              'Trykk på “Ny oppføring”',
              'Trykk på “A-oppføring”',
              'I feltet for "Oppføring", la det stå tomt',
              {
                content: 'I feltet for "Mål", skriv inn',
                target: this.a.target,
              },

              'Lagre endringene ved å trykke opprett',
              'Dersom du har en annen A peker med "Oppføring" som er tom, må denne slettes slik at domenet fungerer riktig.',
            ],
          },
        ]
      }
      return base
    },
  },
  components: {
    Item,
  },
}
</script>

<template>
  <div class="dns-provider-webhuset">
    <Item v-for="(item, index) in items" :value="item" :order="index"> </Item>
  </div>
</template>

<style lang="scss">
.dns-provider-webhuset {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
